/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useMemo } from "react";

import { bem } from "../../../shared/BEM";
import { FormRepository } from "../../../shared/FormRepository";
import { IFormModelDescriptor } from "../../../shared/FormModel/FormModel";
import { DocumentManager } from "../../lib/DocumentManager";
import { useHistory } from "react-router-dom";
import { News } from "../Common/NewsComponent";
import { NewsEntry } from "../Common/NewsEntryComponent";

interface IDocumentCardComponentProps {
	docMgr: DocumentManager;
	item: IFormModelDescriptor;
}

export function DocumentCard(props: IDocumentCardComponentProps) {

	const history = useHistory();

	const clickHandler = useMemo(() => () => {

		const docId = props.docMgr.open(props.item.id, props.item.version);
		history.push("/doc/" + docId);

	}, [props.item]);

	const menuStl = bem("menu-cards");

	return <li className={menuStl.el("item").str}>
		<button className={menuStl.el("card").str} onClick={clickHandler}>
			<i className={`mdi mdi-${props.item.icon}`} />
			<span className={menuStl.el("item-title").str}>{props.item.title}</span>
		</button>
	</li>;

}

/**
 * Component props
 */
export interface IPageNewDocumentComponentProps {
	formRepo: FormRepository;
	docMgr: DocumentManager;
}

/**
 * Menu section
 *
 * @param props Component props
 */
export function PageNewDocument(props: IPageNewDocumentComponentProps) {

	const items = props.formRepo.getList();

	const stl = bem("page");
	const menuStl = bem("menu-cards");
	const menuNews = bem("menu-news");

	return <div className={stl.mod(["new-document", "full-width"]).str}>
		<header className={stl.el("header").str}>
			<h2>Nový dokument</h2>
		</header>
		<ul className={menuStl.str}>
			{items.map((item) =>
				<DocumentCard key={item.id} item={item} docMgr={props.docMgr} />
			)}
		</ul>

		<News>
			<NewsEntry title="15.9. 2020">
				<ul>
					<li>Doplněna možnost <strong>upravovat hlavičky dokumentů</strong></li>
					<li>Upravena položka Provedení sestavy nábytku v <strong>Cenová nabídka - kuchyň</strong></li>
				</ul>
			</NewsEntry>
			<NewsEntry title="3.9. 2020">
				<ul>
					<li>Doplněna <strong>Smlouva o dílo</strong></li>
					<li>Upravena adresa ve <strong>Smlouvě o dílo, GDPR a Dodatku ke smlouvě</strong></li>
					<li>Úpravy v <strong>Odškrtávacím seznamu</strong> a <strong>Zadávacím protokolu</strong></li>
					<li>Úpravy v dokumentu <strong>Připravenost stavby</strong></li>
				</ul>
			</NewsEntry>
			<NewsEntry title="2.9. 2020">
				<ul>
					<li>Doplněn dokument <strong>Připravenost stavby</strong></li>
					<li>Upraveny <strong>Zadávací protokoly</strong></li>
					<li>Doplněny podpisové sekce u všech relevantních dokumentů</li>
					<li>Doplněny smluvní strany do <strong>Smlouvy o dílo</strong></li>
					<li>Doplněna <strong>Cenová nabídka</strong></li>
				</ul>
			</NewsEntry>
			<NewsEntry title="28.8. 2020">
				<ul>
					<li>Upravena patička pro všechny dokumenty</li>
					<li>Přidán dokument <strong>Připravenost stavby</strong></li>
				</ul>
			</NewsEntry>
			<NewsEntry title="27.8. 2020">
				<ul>
					<li>Přidán dokument <strong>Předávací protokol</strong></li>
					<li>Aktualizace formulářů</li>
					<li>Přidány firmy do <strong>GDPR</strong></li>
				</ul>
			</NewsEntry>
			<NewsEntry title="22.8. 2020">
				<ul>
					<li>Přidán dokument <strong>Smlouva o dílo</strong></li>
				</ul>
			</NewsEntry>
			<NewsEntry title="21.8. 2020">
				<ul>
					<li>Aktualizován dokument <strong>Zadávací protokol - online + tisk</strong> - pracujeme na sčítání položek</li>
					<li>Přidán dokument <strong>Odškrtávací seznam - pouze tisk</strong>, který slouží pro analýzu se zákazníkem</li>
					<li>Přidán dokument <strong>Cenová nabídka - obecná</strong>, která slouží pro obecné kalkulace</li>
					<li>Přidán dokument <strong>Interní kalkulace</strong>, který slouží pro výpočet ceny kuchyně - pracujeme na sčítání položek</li>
					<li>Přidán dokument <strong>Dodatek ke smlouvě</strong></li>
					<li>Přidán dokument <strong>Formulář pro zaměření</strong></li>
				</ul>
			</NewsEntry>
		</News>
	</div>;

}
